import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { IS_PRODUCTION } from './app/core/config.service';

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    if (IS_PRODUCTION) {
      enableProdMode();
    }
  })